import React from 'react';
import { Check, X, Minus } from 'lucide-react';

const GhlComparison: React.FC = () => {
  return (
    <section className="py-24 bg-slate-900 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-4">
            ProGeoData vs. The Alternatives
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            GHL marketers have tried everything. Here is how we compare to what you are probably using now.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="p-4 text-left text-slate-500 font-medium text-sm"></th>
                <th className="p-4 text-center bg-emerald-900/10 border-t-4 border-emerald-500 rounded-t-lg">
                  <span className="text-lg font-bold text-white">ProGeoData</span>
                </th>
                <th className="p-4 text-center text-slate-400 font-medium text-sm">Manual Scraping</th>
                <th className="p-4 text-center text-slate-400 font-medium text-sm">List Brokers</th>
                <th className="p-4 text-center text-slate-400 font-medium text-sm">ZoomInfo/Apollo</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800">
              <tr>
                <td className="p-4 text-slate-300 font-medium text-sm">GHL-Ready Format</td>
                <td className="p-4 text-center bg-emerald-900/5">
                  <div className="inline-flex items-center text-emerald-400 font-medium text-sm"><Check className="w-4 h-4 mr-1" /> CSV mapped to GHL</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><Minus className="w-4 h-4 mr-1" /> Manual cleanup</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><Minus className="w-4 h-4 mr-1" /> Varies</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><X className="w-4 h-4 mr-1" /> Not designed for GHL</div>
                </td>
              </tr>
              <tr>
                <td className="p-4 text-slate-300 font-medium text-sm">Licensed Pros Focus</td>
                <td className="p-4 text-center bg-emerald-900/5">
                  <div className="inline-flex items-center text-emerald-400 font-medium text-sm"><Check className="w-4 h-4 mr-1" /> 50+ professions</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><Check className="w-4 h-4 mr-1" /> One at a time</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><Minus className="w-4 h-4 mr-1" /> Hit or miss</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><X className="w-4 h-4 mr-1" /> Generic B2B</div>
                </td>
              </tr>
              <tr>
                <td className="p-4 text-slate-300 font-medium text-sm">License Verification</td>
                <td className="p-4 text-center bg-emerald-900/5">
                  <div className="inline-flex items-center text-emerald-400 font-medium text-sm"><Check className="w-4 h-4 mr-1" /> Real-time, daily</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">Manual lookup</td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><X className="w-4 h-4 mr-1" /> No</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><X className="w-4 h-4 mr-1" /> No</div>
                </td>
              </tr>
              <tr>
                <td className="p-4 text-slate-300 font-medium text-sm">Data Freshness</td>
                <td className="p-4 text-center bg-emerald-900/5 text-white font-medium text-sm">Daily sync</td>
                <td className="p-4 text-center text-slate-500 text-sm">Whenever you scrape</td>
                <td className="p-4 text-center text-slate-500 text-sm">3-6 months old</td>
                <td className="p-4 text-center text-slate-500 text-sm">Quarterly</td>
              </tr>
              <tr>
                <td className="p-4 text-slate-300 font-medium text-sm">Cost</td>
                <td className="p-4 text-center bg-emerald-900/5 font-bold text-white text-sm">$99-499/mo</td>
                <td className="p-4 text-center text-slate-500 text-sm">Your time ($$)</td>
                <td className="p-4 text-center text-slate-500 text-sm">$0.10-0.50/lead</td>
                <td className="p-4 text-center text-slate-500 text-sm">$15,000+/yr</td>
              </tr>
              <tr>
                <td className="p-4 text-slate-300 font-medium text-sm">API Access</td>
                <td className="p-4 text-center bg-emerald-900/5">
                  <div className="inline-flex items-center text-emerald-400 font-medium text-sm"><Check className="w-4 h-4 mr-1" /> Growth+</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><X className="w-4 h-4 mr-1" /> No</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><X className="w-4 h-4 mr-1" /> No</div>
                </td>
                <td className="p-4 text-center text-slate-500 text-sm">
                  <div className="inline-flex items-center"><Check className="w-4 h-4 mr-1" /> Yes</div>
                </td>
              </tr>
              <tr>
                <td className="p-4 text-slate-300 font-medium text-sm">Minimum Commitment</td>
                <td className="p-4 text-center bg-emerald-900/5 text-white font-medium text-sm">Month-to-month</td>
                <td className="p-4 text-center text-slate-500 text-sm">N/A</td>
                <td className="p-4 text-center text-slate-500 text-sm">Per purchase</td>
                <td className="p-4 text-center text-slate-500 text-sm">Annual contract</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default GhlComparison;
